import { useRouter } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export function useFetchProductSourceUrl() {
  const router = useRouter()
  const i18n = useI18n()
  const { data: productResponse } = useFetchProduct()

  const productPageUrl = computed(() => {
    if (!productResponse.value) {
      return ''
    }

    return router.resolve(
      toNuxtLink({
        name: PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE,
        params: {
          locale: toBcp47Locale(i18n.currentLocale),
          slugV2: productResponse.value?.seo.slug,
          uuid: productResponse.value?.productId,
        },
      }),
    ).href
  })

  return productPageUrl
}
